import { ToastrService } from 'ngx-toastr';
import { navContentService } from './../../navigation/nav-content/nav-content.service';
import { Color } from 'ng2-charts';
import {Component, DoCheck, OnInit} from '@angular/core';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {animate, style, transition, trigger} from '@angular/animations';
import {GradientConfig} from '../../../../../app-config';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { PagesService } from 'src/app/pages/home/pages.service';
import { TsdService } from 'src/app/pages/home/tsd/tsd-service';
import { error } from 'console';

@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})
export class NavRightComponent implements OnInit, DoCheck {

  public Timercard:boolean ;
  public visibleUserList: boolean;
  public chatMessage: boolean;
  public friendId: boolean;
  public gradientConfig: any;
  public userName: string;
  public backgroundStyle;
  designation: any;
  userLevel: any;
  userGroup: any;
  serviceApiUrl: any;
  currentUser: any;
 userDetails: any;
 userGroups: any;
  userRoles: any;
  roles: string[];
  notificationData:any = []
  apiCallInterval:any
  viewHistoryMore:any={}
  versionInfo:any
  constructor(private _router: Router,private pageService: PagesService,private navContent: navContentService, private tsdService: TsdService,private toastrService:ToastrService) {
    this.visibleUserList = false;
    this.chatMessage = false;
    this.gradientConfig = GradientConfig.config;
  }

  ngOnInit() {
    this.navContent.headerBackground.subscribe(res =>{
      // debugger;
      this.backgroundStyle = res;
      // console.log("background style nav right", res)
    })
    this.pageService.getVersionInfo().subscribe((x:any)=>{
      this.versionInfo = x.webVersion
    })
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.userDetails = this.currentUser.userDetails[0]
    this.userGroups = this.userDetails.userGroups[0]
    this.userRoles = this.userGroups.userRoles
    this.roles = this.userRoles.map(userRole => userRole.roleName)
    if (sessionStorage.getItem('currentUser') != null) {
      let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      this.userName = currentUser.name;
      this.designation = currentUser.designation;
      this.userLevel =currentUser.userDetails[0].userLevel;
      this.userGroup = currentUser?.userDetails[0]?.userGroupName;
    }
    this.apiCallInterval = setInterval(() => {
      let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      this.pageService.getNotification(currentUser.id).subscribe(
        (response:any) => {
          if(response.length>this.notificationData.length){
            this.toastrService.success("","New notications has been recieved")
          }
          this.notificationData = []
          this.notificationData = response
        },
      );
    }, 10000); // Trigger every 10 seconds
  }
  viewMore(data){
    this.viewHistoryMore = data
  }
  logout() {
    Swal.fire({
      title: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Cancel',
      cancelButtonText: 'Logout',
      cancelButtonColor: 'Red',
      // cancelButtonColour: 'red'
    }).then((result:any) => {
      if (result == true) {
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.pageService.userLogOut(this.currentUser.userName).subscribe((x:any)=>{
          
        })
        sessionStorage.removeItem('currentUser');
        this._router.navigate(['/auth/login']);
        console.log("loged out...",)
        Swal.fire(
          'Logout is Succesfull',
        )
      }
    })
  }
  adminOpen(){
    var that = this;
    this.Timercard = true;

    setTimeout(function(){
      that.Timercard = false;
    },10000);
  }
  onChatToggle(friendID) {
    this.friendId = friendID;
    this.chatMessage = !this.chatMessage;
  }

  ngDoCheck() {
    if (document.querySelector('body').classList.contains('elite-rtl')) {
      this.gradientConfig['rtl-layout'] = true;
    } else {
      this.gradientConfig['rtl-layout'] = false;
    }
  }
  notificationRemove(i,data){
    this.tsdService.notificationDelete(data.id).subscribe(x=>{

    },(error)=>{
      if(error.status == 200){
        this.notificationData.splice(i,1)
        this.toastrService.success("Nofication Deleted Successfully")
        
      }
    })
  

  }
  notificationRemoveNew(i,data){
    this.tsdService.notificationDelete(data.id).subscribe(x=>{

    },(error)=>{
      if(error.status == 200){
        this.notificationData.splice(i,1)
        // this.toastrService.success("Nofication Deleted Successfully")
        
      }
    })
  

  }
  clearAll(){
    Swal.fire({
      title: "Are you sure?",
      text:
        "Do you want to clear all the notification",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      showConfirmButton: true,
      cancelButtonText: "Cancel",
      cancelButtonColor:"red",
    }).then((willDelete) => {
      if (willDelete.dismiss) {
        Swal.fire("", "Cancelled", "error");
      } else {
        this.tsdService.notificationDeleteAll().subscribe((x: any) => {
            Swal.fire("All the notification cleared successfully","success"
            ).then(function () {
              window.location.reload();
            });
          });
      }
    });
  }
}
